/**
 * Book metadata, chapter counts, and audio URL helpers for the ENGESVC2DA audio set.
 *
 * Filename format: {testament}{bookCode}___{chapterPadded}_{formattedName}ENGESVC2DA.mp3
 *   e.g. A01___01_Genesis_____ENGESVC2DA.mp3  (Genesis 1)
 *        B04___03_John________ENGESVC2DA.mp3  (John 3)
 *
 * Psalms is the only exception: it uses 3-digit chapter numbers and only 2 underscores
 * before the chapter, e.g. A19__119_Psalms______ENGESVC2DA.mp3 (Psalm 119).
 *
 * Extracted from ten-lists/src/js/main.js — keep in sync if the naming convention changes.
 */

export const bookNameMap = {
  // Old Testament
  'Genesis':         { bookCode: '01', testament: 'A', formattedName: 'Genesis_____' },
  'Exodus':          { bookCode: '02', testament: 'A', formattedName: 'Exodus______' },
  'Leviticus':       { bookCode: '03', testament: 'A', formattedName: 'Leviticus___' },
  'Numbers':         { bookCode: '04', testament: 'A', formattedName: 'Numbers_____' },
  'Deuteronomy':     { bookCode: '05', testament: 'A', formattedName: 'Deuteronomy_' },
  'Joshua':          { bookCode: '06', testament: 'A', formattedName: 'Joshua______' },
  'Judges':          { bookCode: '07', testament: 'A', formattedName: 'Judges______' },
  'Ruth':            { bookCode: '08', testament: 'A', formattedName: 'Ruth________' },
  '1 Samuel':        { bookCode: '09', testament: 'A', formattedName: '1Samuel_____' },
  '2 Samuel':        { bookCode: '10', testament: 'A', formattedName: '2Samuel_____' },
  '1 Kings':         { bookCode: '11', testament: 'A', formattedName: '1Kings______' },
  '2 Kings':         { bookCode: '12', testament: 'A', formattedName: '2Kings______' },
  '1 Chronicles':    { bookCode: '13', testament: 'A', formattedName: '1Chronicles_' },
  '2 Chronicles':    { bookCode: '14', testament: 'A', formattedName: '2Chronicles_' },
  'Ezra':            { bookCode: '15', testament: 'A', formattedName: 'Ezra________' },
  'Nehemiah':        { bookCode: '16', testament: 'A', formattedName: 'Nehemiah____' },
  'Esther':          { bookCode: '17', testament: 'A', formattedName: 'Esther______' },
  'Job':             { bookCode: '18', testament: 'A', formattedName: 'Job_________' },
  'Psalms':          { bookCode: '19', testament: 'A', formattedName: 'Psalms______' },
  'Proverbs':        { bookCode: '20', testament: 'A', formattedName: 'Proverbs____' },
  'Ecclesiastes':    { bookCode: '21', testament: 'A', formattedName: 'Ecclesiastes' },
  'Song of Solomon': { bookCode: '22', testament: 'A', formattedName: 'SongofSongs_' },
  'Isaiah':          { bookCode: '23', testament: 'A', formattedName: 'Isaiah______' },
  'Jeremiah':        { bookCode: '24', testament: 'A', formattedName: 'Jeremiah____' },
  'Lamentations':    { bookCode: '25', testament: 'A', formattedName: 'Lamentations' },
  'Ezekiel':         { bookCode: '26', testament: 'A', formattedName: 'Ezekiel_____' },
  'Daniel':          { bookCode: '27', testament: 'A', formattedName: 'Daniel______' },
  'Hosea':           { bookCode: '28', testament: 'A', formattedName: 'Hosea_______' },
  'Joel':            { bookCode: '29', testament: 'A', formattedName: 'Joel________' },
  'Amos':            { bookCode: '30', testament: 'A', formattedName: 'Amos________' },
  'Obadiah':         { bookCode: '31', testament: 'A', formattedName: 'Obadiah_____' },
  'Jonah':           { bookCode: '32', testament: 'A', formattedName: 'Jonah_______' },
  'Micah':           { bookCode: '33', testament: 'A', formattedName: 'Micah_______' },
  'Nahum':           { bookCode: '34', testament: 'A', formattedName: 'Nahum_______' },
  'Habakkuk':        { bookCode: '35', testament: 'A', formattedName: 'Habakkuk____' },
  'Zephaniah':       { bookCode: '36', testament: 'A', formattedName: 'Zephaniah___' },
  'Haggai':          { bookCode: '37', testament: 'A', formattedName: 'Haggai______' },
  'Zechariah':       { bookCode: '38', testament: 'A', formattedName: 'Zechariah___' },
  'Malachi':         { bookCode: '39', testament: 'A', formattedName: 'Malachi_____' },

  // New Testament
  'Matthew':          { bookCode: '01', testament: 'B', formattedName: 'Matthew_____' },
  'Mark':             { bookCode: '02', testament: 'B', formattedName: 'Mark________' },
  'Luke':             { bookCode: '03', testament: 'B', formattedName: 'Luke________' },
  'John':             { bookCode: '04', testament: 'B', formattedName: 'John________' },
  'Acts':             { bookCode: '05', testament: 'B', formattedName: 'Acts________' },
  'Romans':           { bookCode: '06', testament: 'B', formattedName: 'Romans______' },
  '1 Corinthians':    { bookCode: '07', testament: 'B', formattedName: '1Corinthians' },
  '2 Corinthians':    { bookCode: '08', testament: 'B', formattedName: '2Corinthians' },
  'Galatians':        { bookCode: '09', testament: 'B', formattedName: 'Galatians___' },
  'Ephesians':        { bookCode: '10', testament: 'B', formattedName: 'Ephesians___' },
  'Philippians':      { bookCode: '11', testament: 'B', formattedName: 'Philippians_' },
  'Colossians':       { bookCode: '12', testament: 'B', formattedName: 'Colossians__' },
  '1 Thessalonians':  { bookCode: '13', testament: 'B', formattedName: '1Thess______' },
  '2 Thessalonians':  { bookCode: '14', testament: 'B', formattedName: '2Thess______' },
  '1 Timothy':        { bookCode: '15', testament: 'B', formattedName: '1Timothy____' },
  '2 Timothy':        { bookCode: '16', testament: 'B', formattedName: '2Timothy____' },
  'Titus':            { bookCode: '17', testament: 'B', formattedName: 'Titus_______' },
  'Philemon':         { bookCode: '18', testament: 'B', formattedName: 'Philemon____' },
  'Hebrews':          { bookCode: '19', testament: 'B', formattedName: 'Hebrews_____' },
  'James':            { bookCode: '20', testament: 'B', formattedName: 'James_______' },
  '1 Peter':          { bookCode: '21', testament: 'B', formattedName: '1Peter______' },
  '2 Peter':          { bookCode: '22', testament: 'B', formattedName: '2Peter______' },
  '1 John':           { bookCode: '23', testament: 'B', formattedName: '1John_______' },
  '2 John':           { bookCode: '24', testament: 'B', formattedName: '2John_______' },
  '3 John':           { bookCode: '25', testament: 'B', formattedName: '3John_______' },
  'Jude':             { bookCode: '26', testament: 'B', formattedName: 'Jude________' },
  'Revelation':       { bookCode: '27', testament: 'B', formattedName: 'Revelation__' },
}

export const chapterCounts = {
  'Genesis': 50, 'Exodus': 40, 'Leviticus': 27, 'Numbers': 36, 'Deuteronomy': 34,
  'Joshua': 24, 'Judges': 21, 'Ruth': 4, '1 Samuel': 31, '2 Samuel': 24,
  '1 Kings': 22, '2 Kings': 25, '1 Chronicles': 29, '2 Chronicles': 36,
  'Ezra': 10, 'Nehemiah': 13, 'Esther': 10, 'Job': 42, 'Psalms': 150,
  'Proverbs': 31, 'Ecclesiastes': 12, 'Song of Solomon': 8, 'Isaiah': 66,
  'Jeremiah': 52, 'Lamentations': 5, 'Ezekiel': 48, 'Daniel': 12, 'Hosea': 14,
  'Joel': 3, 'Amos': 9, 'Obadiah': 1, 'Jonah': 4, 'Micah': 7, 'Nahum': 3,
  'Habakkuk': 3, 'Zephaniah': 3, 'Haggai': 2, 'Zechariah': 14, 'Malachi': 4,
  'Matthew': 28, 'Mark': 16, 'Luke': 24, 'John': 21, 'Acts': 28, 'Romans': 16,
  '1 Corinthians': 16, '2 Corinthians': 13, 'Galatians': 6, 'Ephesians': 6,
  'Philippians': 4, 'Colossians': 4, '1 Thessalonians': 5, '2 Thessalonians': 3,
  '1 Timothy': 6, '2 Timothy': 4, 'Titus': 3, 'Philemon': 1, 'Hebrews': 13,
  'James': 5, '1 Peter': 5, '2 Peter': 3, '1 John': 5, '2 John': 1,
  '3 John': 1, 'Jude': 1, 'Revelation': 22,
}

// Canonical Bible order for the UI
export const OLD_TESTAMENT = [
  'Genesis', 'Exodus', 'Leviticus', 'Numbers', 'Deuteronomy',
  'Joshua', 'Judges', 'Ruth', '1 Samuel', '2 Samuel',
  '1 Kings', '2 Kings', '1 Chronicles', '2 Chronicles',
  'Ezra', 'Nehemiah', 'Esther', 'Job', 'Psalms', 'Proverbs',
  'Ecclesiastes', 'Song of Solomon', 'Isaiah', 'Jeremiah',
  'Lamentations', 'Ezekiel', 'Daniel', 'Hosea', 'Joel', 'Amos',
  'Obadiah', 'Jonah', 'Micah', 'Nahum', 'Habakkuk', 'Zephaniah',
  'Haggai', 'Zechariah', 'Malachi',
]

export const NEW_TESTAMENT = [
  'Matthew', 'Mark', 'Luke', 'John', 'Acts', 'Romans',
  '1 Corinthians', '2 Corinthians', 'Galatians', 'Ephesians',
  'Philippians', 'Colossians', '1 Thessalonians', '2 Thessalonians',
  '1 Timothy', '2 Timothy', 'Titus', 'Philemon', 'Hebrews',
  'James', '1 Peter', '2 Peter', '1 John', '2 John', '3 John',
  'Jude', 'Revelation',
]

/**
 * Returns the number of chapters in a book, or 0 if the book name is unknown.
 * @param {string} bookName - Canonical book name (e.g. 'Genesis', '1 Samuel')
 * @returns {number}
 */
export function getChapterCount(bookName) {
  return chapterCounts[bookName] || 0
}

/**
 * Returns the full URL for a single chapter's audio file.
 * @param {string} bookName - Canonical book name
 * @param {number} chapter  - 1-based chapter number
 * @param {string} baseUrl  - Base URL of the audio storage (no trailing slash)
 * @returns {string} Absolute or relative URL, or '' if bookName is unknown
 */
export function getAudioFilePath(bookName, chapter, baseUrl) {
  const bookInfo = bookNameMap[bookName]
  if (!bookInfo) return ''

  const chapterFormatted = chapter.toString().padStart(2, '0')
  let fileName

  // Psalms uses 3-digit chapter numbers and only 2 underscores before the chapter
  // because Psalm 119 would overflow 2 digits. All other books use 3 underscores + 2 digits.
  if (bookName === 'Psalms') {
    const psalmChapterFormatted = chapter.toString().padStart(3, '0')
    fileName = `${bookInfo.testament}${bookInfo.bookCode}__${psalmChapterFormatted}_${bookInfo.formattedName}ENGESVC2DA.mp3`
  } else {
    fileName = `${bookInfo.testament}${bookInfo.bookCode}___${chapterFormatted}_${bookInfo.formattedName}ENGESVC2DA.mp3`
  }

  return `${baseUrl}/${fileName}`
}

/**
 * Returns an ordered array of audio URLs for every chapter in a book.
 * @param {string} bookName - Canonical book name
 * @param {string} baseUrl  - Base URL of the audio storage (no trailing slash)
 * @returns {string[]}
 */
export function getBookChapterUrls(bookName, baseUrl) {
  const count = getChapterCount(bookName)
  return Array.from({ length: count }, (_, i) => getAudioFilePath(bookName, i + 1, baseUrl))
}

/**
 * Returns a URL-safe slug for a book name (lowercase, spaces → hyphens).
 * e.g. '1 Samuel' → '1-samuel', 'Song of Solomon' → 'song-of-solomon'
 * @param {string} bookName
 * @returns {string}
 */
export function getBookSlug(bookName) {
  return bookName.toLowerCase().replace(/\s+/g, '-')
}

export const LISTS = [
  { name: 'The Gospels', books: ['Matthew', 'Mark', 'Luke', 'John'] },
  { name: 'The Pentateuch', books: ['Genesis', 'Exodus', 'Leviticus', 'Numbers', 'Deuteronomy'] },
  { name: "Paul's Letters", books: ['Romans', '1 Corinthians', '2 Corinthians', 'Galatians', 'Ephesians', 'Philippians', 'Colossians', 'Hebrews'] },
  { name: 'General Epistles', books: ['1 Thessalonians', '2 Thessalonians', '1 Timothy', '2 Timothy', 'Titus', 'Philemon', 'James', '1 Peter', '2 Peter', '1 John', '2 John', '3 John', 'Jude', 'Revelation'] },
  { name: 'Wisdom (Poetry)', books: ['Job', 'Ecclesiastes', 'Song of Solomon'] },
  { name: 'Psalms', books: ['Psalms'] },
  { name: 'Proverbs', books: ['Proverbs'] },
  { name: 'Historical Books', books: ['Joshua', 'Judges', 'Ruth', '1 Samuel', '2 Samuel', '1 Kings', '2 Kings', '1 Chronicles', '2 Chronicles', 'Ezra', 'Nehemiah', 'Esther'] },
  { name: 'The Prophets', books: ['Isaiah', 'Jeremiah', 'Lamentations', 'Ezekiel', 'Daniel', 'Hosea', 'Joel', 'Amos', 'Obadiah', 'Jonah', 'Micah', 'Nahum', 'Habakkuk', 'Zephaniah', 'Haggai', 'Zechariah', 'Malachi'] },
  { name: 'Acts', books: ['Acts'] },
]
